import Fav from './Fav.jsx';

export default Fav;